import React from "react";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb, Icon } from "antd";
import { breadcrumbNameMap } from "../../Modules/utils";

class BreadCrumbComponent extends React.Component {
  render() {
    const {
      location: { pathname }
    } = this.props;
    const pathSnippets = pathname.split("/").filter(i => i);
    const last = pathSnippets[pathSnippets.length - 1];
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
      return (
        <Breadcrumb.Item key={url}>
          <Link to={url}>{breadcrumbNameMap[url] || last}</Link>
        </Breadcrumb.Item>
      );
    });
    const breadcrumbItems = [
      <Breadcrumb.Item key="home">
        <Link to="/">
          <Icon type="home" style={{ fontSize: 16 }} />
        </Link>
      </Breadcrumb.Item>
    ].concat(extraBreadcrumbItems);
    return (
      <Breadcrumb style={{ margin: "16px 0" }}>{breadcrumbItems}</Breadcrumb>
    );
  }
}

export default withRouter(BreadCrumbComponent);



// WEBPACK FOOTER //
// ./src/Components/Navigation/Breadcrumb.js